import React from "react";

import { addToQueue } from "./actions";
import AddSongFlow from "../../../service/add-song-flow";
import PlaylistService from "../../../service/playlist-service";
import { ModalService, ModalTypes } from "../../../service/modal-service";
import { ConfirmModal } from "../../../modals";
import { withStyles } from "@material-ui/core/styles";
import MaterialButton from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Theme } from "../../../theme/theme-provider";

import {
  faTrashAlt,
  faEllipsisH,
  faPlus,
  faHeadphones,
  faGlobeAsia,
} from "@fortawesome/free-solid-svg-icons";

const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: `red`,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);

export default function CustomizedMenus({ playlist, refresh }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { isPublic } = playlist;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAddToQueue = () => {
    addToQueue({ playlistId: playlist.id });
  };

  const handleAddSong = () => {
    AddSongFlow.initiate({ type: "playlist", id: playlist.id, onAdd: refresh });
  };

  const changeVisibility = () => {
    const change = async () => {
      const isEdited = await PlaylistService.editPlaylist({
        id: playlist.id,
        makePublic: !isPublic,
        makePrivate: isPublic,
      });
      if (isEdited) refresh();
    };
    ModalService.showModal(ModalTypes.CUSTOM, {
      width: "30%",
      height: "140px",
      content: (
        <ConfirmModal
          title={`Are you sure you want to make this playlist ${
            playlist.isPublic ? "private" : "public"
          }`}
          handleSubmit={change}
        />
      ),
    });
  };

  const deletePlaylist = () => {
    const delete_ = async () => {
      const isDeleted = await PlaylistService.deletePlaylist({
        id: playlist.id,
      });
      if (isDeleted) refresh();
    };
    ModalService.showModal(ModalTypes.CUSTOM, {
      width: "30%",
      height: "140px",
      content: (
        <ConfirmModal
          title={`Are you sure you want to delete this playlist`}
          handleSubmit={delete_}
        />
      ),
    });
  };

  const options = [
    {
      text: "Add Songs",
      icon: faPlus,
      onClick: () => {
        handleAddSong();
        handleClose();
      },
    },
    {
      text: "Add to Queue",
      icon: faHeadphones,
      onClick: () => {
        handleAddToQueue();
        handleClose();
      },
    },
    {
      text: `Make ${isPublic ? "private" : "public"}`,
      icon: faGlobeAsia,
      onClick: () => {
        changeVisibility();
        handleClose();
      },
    },
    {
      text: "Delete Playlist",
      icon: faTrashAlt,
      onClick: () => {
        deletePlaylist();
        handleClose();
      },
    },
  ];

  return (
    <div>
      <MaterialButton
        style={{
          borderRadius: 50,
          color: Theme.color.BLUE_5,
          borderColor: Theme.color.BLUE_5,
        }}
        aria-controls="customized-menu"
        aria-haspopup="true"
        variant="outlined"
        onClick={handleClick}
      >
        <FontAwesomeIcon icon={faEllipsisH} />
      </MaterialButton>
      <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        id="customized-menu"
        anchorEl={anchorEl}
        style={{ color: "#fff" }}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {options.map(({ text, icon, onClick }) => (
          <StyledMenuItem onClick={onClick}>
            <ListItemIcon>
              <FontAwesomeIcon icon={icon} />
            </ListItemIcon>
            <ListItemText primary={text} />
          </StyledMenuItem>
        ))}
      </Menu>
    </div>
  );
}
